import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, Transition as _Transition } from "vue";
import _imports_0 from '../../assets/arrow-right.png';
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 0,
    class: "voucher-list"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "bold" };
const _hoisted_6 = { class: "totalVouchers" };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { style: { "display": "flex", "justify-content": "space-between", "align-items": "center" } };
const _hoisted_9 = { style: { "display": "flex", "align-items": "center" } };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["src"];
const _hoisted_12 = { class: "bold" };
const _hoisted_13 = {
    key: 0,
    class: "expired"
};
const _hoisted_14 = {
    key: 1,
    class: "expires"
};
const _hoisted_15 = { class: "totalVouchers" };
import { ref, onMounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GroupedVoucherList',
    props: {
        search: { type: Boolean, default: false },
        preSearch: { default: null },
        categories: { default: null },
        vouchers: { default: () => [] },
        groupedVouchers: { default: () => [] },
        formatter: { default: null },
        today: { default: null },
        yesterday: { default: null },
        showSaving: { type: Boolean, default: false },
        spendLabel: { default: null },
        label: { default: 'voucher' },
        showFavourites: { type: Boolean, default: false },
        merchantId: { default: null }
    },
    emits: ["favouriteToggled", "group-clicked", "voucher-clicked", "exit-group-view"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const query = ref(props.preSearch ?? null);
        const context = ref(false);
        const selectedGroupVouchers = ref([]);
        const sortOption = ref('recentlyUsed');
        function formattedTransactionDate(createdDateTime) {
            const date = new Date(createdDateTime);
            if (isNaN(date.getTime())) {
                return 'Invalid Date';
            }
            const day = String(date.getDate()).padStart(2, '0');
            const month = date.toLocaleString('default', { month: 'long' });
            const year = date.getFullYear();
            return `${day} ${month}, ${year}`;
        }
        function handleGroupClick(v) {
            console.log('handleGroupClick:', v);
            emit('group-clicked', v);
            console.log('vouchers:', props.vouchers);
        }
        function handleVoucherClick(voucher) {
            emit('voucher-clicked', voucher);
        }
        function sortVouchers() {
            if (sortOption.value === 'recentlyUsed') {
                selectedGroupVouchers.value.sort((a, b) => {
                    const aLatestTransaction = Math.max(...a.customerVoucherTransactions.map((t) => new Date(t.createdDateTime).getTime()));
                    const bLatestTransaction = Math.max(...b.customerVoucherTransactions.map((t) => new Date(t.createdDateTime).getTime()));
                    return bLatestTransaction - aLatestTransaction;
                });
            }
            else if (sortOption.value === 'recentlyPurchased') {
                selectedGroupVouchers.value.sort((a, b) => new Date(b.createdDateTime).getTime() - new Date(a.createdDateTime).getTime());
            }
        }
        onMounted(() => {
            sortVouchers();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            return (_openBlock(), _createElementBlock("div", {
                class: "voucher-list",
                onClick: _cache[2] || (_cache[2] = event => { event.stopPropagation(); })
            }, [
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_ctx.vouchers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                (!_ctx.merchantId)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vouchers, (v) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: v.id
                                            }, [
                                                _createElementVNode("a", {
                                                    onClick: ($event) => (handleGroupClick(v))
                                                }, [
                                                    _createVNode(_component_v_row, { class: "voucherRow" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                                class: "v-col-3 icon-col",
                                                                style: {}
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    (v.cardUrl)
                                                                        ? (_openBlock(), _createElementBlock("img", {
                                                                            key: 0,
                                                                            src: v.cardUrl,
                                                                            class: _normalizeClass('icon ' + (_ctx.showSaving ? 'mt-3' : 'mt-2'))
                                                                        }, null, 10, _hoisted_4))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, { class: "v-col-4 details-col" }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("span", _hoisted_5, _toDisplayString(v.merchantName), 1),
                                                                    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
                                                                ]),
                                                                _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, { class: "v-col-5 amount-col" }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("span", _hoisted_6, [
                                                                        _createTextVNode(_toDisplayString(v.totalVouchers) + " " + _toDisplayString(v.totalVouchers > 1 ? _ctx.label + 's' : _ctx.label) + " ", 1),
                                                                        _cache[4] || (_cache[4] = _createElementVNode("img", {
                                                                            class: "arrow",
                                                                            src: _imports_0
                                                                        }, null, -1))
                                                                    ])
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_divider, { class: "mt-2 mb-6" })
                                                ], 8, _hoisted_3)
                                            ]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _cache[8] || (_cache[8] = _createTextVNode(" Archived ")),
                                            _createElementVNode("div", _hoisted_9, [
                                                _cache[7] || (_cache[7] = _createElementVNode("span", null, "Sort by: ", -1)),
                                                _createVNode(_component_v_menu, null, {
                                                    activator: _withCtx(({ props }) => [
                                                        _createElementVNode("div", _mergeProps(props, { class: "mg-circle-icon-button" }), [
                                                            _createElementVNode("span", null, _toDisplayString(sortOption.value === 'recentlyUsed' ? 'Recently used' : 'Recently purchased'), 1)
                                                        ], 16)
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_list, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item, {
                                                                    onClick: _cache[0] || (_cache[0] = ($event) => { sortOption.value = 'recentlyUsed'; sortVouchers(); })
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_v_icon, { icon: "mdi-clock-outline" }),
                                                                        _cache[5] || (_cache[5] = _createTextVNode(" Recently used "))
                                                                    ]),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_v_list_item, {
                                                                    onClick: _cache[1] || (_cache[1] = ($event) => { sortOption.value = 'recentlyPurchased'; sortVouchers(); })
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_v_icon, { icon: "mdi-cart-outline" }),
                                                                        _cache[6] || (_cache[6] = _createTextVNode(" Recently purchased "))
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ])
                                        ]),
                                        _createVNode(_component_v_divider, { class: "mt-2 mb-6" }),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vouchers.vouchers, (voucher) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: voucher.id
                                            }, [
                                                _createElementVNode("a", {
                                                    onClick: ($event) => (handleVoucherClick(voucher))
                                                }, [
                                                    _createVNode(_component_v_row, { class: "voucherRow" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { class: "v-col-3 icon-col" }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("img", {
                                                                        src: voucher.discount.cardUrl,
                                                                        class: "icon"
                                                                    }, null, 8, _hoisted_11)
                                                                ]),
                                                                _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, { class: "v-col-6 details-col" }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("span", _hoisted_12, _toDisplayString(voucher.discount.merchant?.name || 'Unknown Merchant'), 1),
                                                                    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                                                    (voucher.expiryDateTime < new Date())
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Expired: " + _toDisplayString(formattedTransactionDate(voucher.expiryDateTime)), 1))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_14, "Expires: " + _toDisplayString(formattedTransactionDate(voucher.expiryDateTime)), 1))
                                                                ]),
                                                                _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, { class: "v-col-2 amount-col" }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatter.format(voucher.faceValue)), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ], 8, _hoisted_10),
                                                _createVNode(_component_v_divider, { class: "mt-2 mb-6" })
                                            ]));
                                        }), 128))
                                    ]))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
